
// ページトップボタンの表示 // Display the page top button
// jQuery(function($) {

// 	if ( $('#pageup').length > 0 ) {
// 		var topBtn = $('#pageup');
// 		topBtn.css("display", "none");
// 		//スクロールが100に達したらボタン表示 // display button when scroll reaches 100
// 		$(window).scroll(function () {
// 			if ($(this).scrollTop() > 100) {
// 				topBtn.fadeIn();
// 			} else {
// 				topBtn.fadeOut();
// 			}
// 		});
// 		//スクロールしてトップ // scroll to the top
// 		topBtn.click(function () {
// 			$('body,html').animate({
// 				scrollTop: 0
// 			}, 500);
// 			return false;
// 		});
// 	}
// });


// ページ内アンカーリンクのスクロールエフェクト // Scrolling effect for anchor links within the page
// ヘッダーが固定の場合はheaderHightにヘッダーの高さを設定(PC/SP要設定) // Set header height to headerHight if header is fixed (PC/SP setting required)
jQuery(function($) {
    // var headerHeight = 0; // ヘッダー追従でない場合 // if not header-following
	var headerHeight = $('header').innerHeight(); // ヘッダー追従の場合 // if header following
    $('a[href^="#"]').click(function(){
        var href= $(this).attr("href");
        var target = $(href == "#" || href == "" ? 'html' : href);
        if ( target.length > 0 ) {
            var position = target.offset().top - headerHeight;
            $("html, body").animate({scrollTop:position}, 550, "swing");
            return false;
        }
    });
})

// 沿革ナビの現在位置を更新 // Update the active history navigation item on scroll
jQuery(function($) {
	var $navLinks = $('.p-historyCont__nav ul a[href^="#"]');
	var sections = [];
	var ticking = false;

	if ($navLinks.length === 0) {
		return;
	}

	$navLinks.each(function() {
		var section = document.getElementById(this.hash.substring(1));

		if (section) {
			sections.push({
				id: section.id,
				$section: $(section)
			});
		}
	});

	if (sections.length === 0) {
		return;
	}

	function updateHistoryNav() {
		var headerHeight = $('header').outerHeight() || 0;
		var activationLine = $(window).scrollTop() + Math.max(headerHeight, 120) + 24;
		var activeId = sections[0].id;

		for (var i = 0; i < sections.length; i++) {
			if (sections[i].$section.offset().top <= activationLine) {
				activeId = sections[i].id;
			} else {
				break;
			}
		}

		var $activeLink = $navLinks.filter('[href="#' + activeId + '"]');

		if (!$activeLink.hasClass('active')) {
			$navLinks.removeClass('active').removeAttr('aria-current');
			$activeLink.addClass('active').attr('aria-current', 'true');
		} else if (!$activeLink.attr('aria-current')) {
			$activeLink.attr('aria-current', 'true');
		}
	}

	function requestHistoryNavUpdate() {
		if (!ticking) {
			window.requestAnimationFrame(function() {
				updateHistoryNav();
				ticking = false;
			});
			ticking = true;
		}
	}

	$(window).on('scroll.historyNav resize.historyNav load.historyNav', requestHistoryNavUpdate);
	updateHistoryNav();
});


// ヘッダーの固定エフェクト // Fixed header effect
jQuery(function($) {
	var $header = $('header');
	$(window).scroll(function() {
		if ($(window).scrollTop() > 50) {
			$header.addClass('fixed');
		} else {
			$header.removeClass('fixed');
		}
	});
});



// レスポンシブ画像切り替え imgにclass「js-image-switch」// responsive image switch class "js-image-switch" in img
jQuery(function($) {

	if ( $('.js-image-switch').length > 0 ) {

		var $elem = $('.js-image-switch');
		var sp = '_sp.';
		var pc = '_pc.';
		// 画像を切り替えるウィンドウサイズ // Window size to switch images
		var replaceWidth = 768;

		function imageSwitch() {
			var windowWidth = parseInt($(window).width());
			$elem.each(function() {
				var $this = $(this);
				if(windowWidth >= replaceWidth) {
				$this.attr('src', $this.attr('src').replace(sp, pc));
				} else {
					$this.attr('src', $this.attr('src').replace(pc, sp));
				}
			});
		}
		imageSwitch();

		var resizeTimer;
		$(window).on('resize', function() {
			clearTimeout(resizeTimer);
			resizeTimer = setTimeout(function() {
				imageSwitch();
			}, 200);
		});
	}
});


// アコーディオンの起動 // Activate the accordion
jQuery(function($) {


	if ( $('dl.accordion dt').length > 0 ) {

		$("dl.accordion dt").click(function(){
			$(this).next("dd").slideToggle();
			$(this).toggleClass("open");
		});
	}
});

// ドロワーメニュー // Drawer menu
jQuery(function($) {
    if ($('#toggle').length > 0) {
		$('#toggle').click(function () {
			$(this).toggleClass('toggle_active');
			$('#drawer_layer').fadeToggle();
			$('body').toggleClass('drawer_open');

			if ($(this).hasClass('toggle_active')) {
				$('nav').addClass('is_open');
				$('nav').removeClass('is_close');
			} else {
				$('nav').removeClass('is_open');
				$('nav').addClass('is_close');
			}
		});

		$('#drawer_layer').click(function () {
			$(this).fadeOut();
			$('#toggle').removeClass('toggle_active');
			$('body').removeClass('drawer_open');
			$('nav').removeClass('is_open');
			$('nav').addClass('is_close');
		});

		// エリア内リンク用 // For links within an area
		$('nav a').on('click', function(){
			// if (window.innerWidth <= 768) {
			if ($('#toggle:visible').length > 0) {
				$('#toggle').click();
			}
		});
	}

});


// ヘッダーの企業情報ドロップダウン // Company information dropdown in the header
jQuery(function($) {
	var $dropdown = $('.js-header-dropdown');
	var $trigger = $dropdown.find('.js-header-dropdown-trigger');

	if ($dropdown.length === 0) {
		return;
	}

	function closeDropdown(returnFocus) {
		$dropdown.removeClass('is-open');
		$trigger.attr('aria-expanded', 'false');

		if (returnFocus) {
			$trigger.trigger('focus');
		}
	}

	$trigger.on('click', function(event) {
		event.stopPropagation();

		var willOpen = !$dropdown.hasClass('is-open');
		$dropdown.toggleClass('is-open', willOpen);
		$(this).attr('aria-expanded', willOpen ? 'true' : 'false');
	});

	$dropdown.on('click', function(event) {
		event.stopPropagation();
	});

	$(document).on('click.headerDropdown', function() {
		closeDropdown(false);
	});

	$(document).on('keydown.headerDropdown', function(event) {
		if (event.key === 'Escape' && $dropdown.hasClass('is-open')) {
			closeDropdown(true);
		}
	});
});


// facebookプラグインリサイズ処理 // facebook plugin resizing process
jQuery(function($) {

	if ( $('#pageplugin').length > 0 ) {

		var windowWidth = $(window).width();
		var htmlStr = $('#pageplugin').html();
		var timer = null;
		$(window).on('resize',function() {
			var resizedWidth = $(window).width();
			if(windowWidth != resizedWidth && resizedWidth < 500) {
				clearTimeout(timer);
				timer = setTimeout(function() {
					$('#pageplugin').html(htmlStr);
					window.FB.XFBML.parse();
			   		//window.FB.XFBML.parse()で再レンダリングします。// re-render with window.FB.XFBML.parse(); window.FB.XFBML.parse()
					var windowWidth = $(window).width();
				}, 500);
			}
		});
	}
});

jQuery(function ($) {
//二重送信抑制
	let submitBtn = $("input[type='submit'].wpcf7-submit");
	submitBtn.click(function () {
		$(this).css('pointer-events', 'none');
		$(this).css('opacity', '0.5');
	})
	// 入力項目にエラーがあったらボタン復活
	document.addEventListener('wpcf7invalid', function () {
		submitBtn.css('pointer-events', 'auto');
		submitBtn.css('opacity', '1');
	}, false);

});


const swiper = new Swiper(".recruit-swiper", {
  speed: 4000, // スライド変化時間
  loop: true,
	loopAdditionalSlides: 1,
	slidesPerView: 'auto',
	spaceBetween: 15,
  autoplay: {
		delay: 0, //　スライダー表示時間
    disableOnInteraction: false,
	},
	breakpoints: {
		769: {
			spaceBetween: 25

		}
	}

});
